const subjectOptions = ["Erhverv", "Landbrug"];

export default subjectOptions;
